import RightDefaultLayout from './RightDefaultLayout';

export default RightDefaultLayout;